import styled from 'styled-components';
import * as color from 'modules/common/theme/color';
import * as font from 'modules/common/theme/font';

const Notification = styled.div`
  font-size: 13px;
  font-family: ${font.MontserratFont};
`;

Notification.Text = styled.div`
  color: ${color.White};
`;

export default {
  Notification,
};
